export default {
  methods: {
    joinParam(param) {
      return param.join(',')
    },
    splitParam(param) {
      return param ? param.split(',') : []
    },
    handleListChange({ filter, sort, currentPage }) {
      const query = {
        cateId: filter.cateId,
        hasStock: filter.hasStock ? 1 : 0,
        keyword: filter.keyword,
        marks: this.joinParam(filter.marks),
        secondCates: this.joinParam(filter.secondCates),
        sortPrice: sort.price,
        page: currentPage,
      }
      this.$router.push({name: this.$route.name, query })
    }
  },
  computed: {
    filter() {
      return {
        cateId: this.currentTopCateId ? this.currentTopCateId: 0,
        hasStock: this.$route.query.hasStock == '1' || typeof this.$route.query.hasStock === 'undefined',
        marks: this.splitParam(this.$route.query.marks),
        keyword: this.$route.query.keyword,
        secondCates: this.splitParam(this.$route.query.secondCates),
      }
    },
    currentPage() {
      return this.$route.query.page > 0 ? Number(this.$route.query.page) : 1
    },
    sort() {
      return {
        price: this.$route.query.sortPrice ? this.$route.query.sortPrice : 'asc'
      }
    }
  }
}
